<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-list-item lc-list-body__row">
    <div v-if="index!==''" class="index">
      {{ index }}
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LcListItem',
  props: {
    index: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
